import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";


export const JwtInterceptor : HttpInterceptorFn = (req, next) => {
    let authService = inject(AuthService);
    let currentUser = authService.currentUserValue;

    if (currentUser && currentUser.accessToken) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${currentUser.accessToken}`
            }
        });
    }
    return next(req);
}
